module.exports = __webpack_public_path__ + "img/ycc_exchange_1000.695f33e7.png";